import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbNavigationService, ConfigurationService, TrackingV2Service } from '@draeger-academy/common';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'da-partner-event-details',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EventDetailsComponent implements OnInit, OnDestroy {
    private _sub: Subscription;
    public portal: string;
    constructor(
        private _configurationService: ConfigurationService,
        private _localizeRouterService: LocalizeRouterService,
        private router: Router,
        private _breadcrumbNavigationService: BreadcrumbNavigationService,
        private _trackingV2Service: TrackingV2Service
    ) {}

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this._sub = this._configurationService.getPortalVersion().subscribe((portalVersion) => {
            if (portalVersion && portalVersion !== 'v2') {
                this.router.navigate(['/page-not-found'], { skipLocationChange: true });
            }
        });
        this._configurationService.currentPortal$.subscribe((portal) => {
            if (portal) {
                this.portal = portal.toUpperCase().replace(new RegExp('-', 'g'), '_');
                this._trackPage();
            }
        });
    }

    private _trackPage() {
        this._trackingV2Service.loadTrackingScript();
        this._trackingV2Service.trackPage({
            template: 'EventDetailPage',
            title: 'Dräger Academy Partnerportal ' + this.portal + ' | Event Detail'
        });
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
        this._breadcrumbNavigationService.resetBreadcrumb();
    }
}
